const filter = (value): string => {
  if (!value) {
    return ''
  }

  const regionsEnum = {
    BR: 'Brasil',
    CO: 'Centro-Oeste',
    N: 'Norte',
    NE: 'Nordeste',
    S: 'Sul',
    SE: 'Sudeste'
  }

  return regionsEnum[value] || value
}

export default filter
